module.exports = __webpack_public_path__ + "6d8eff33.png";